import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Send, MessageCircle } from "lucide-react";

const CAT_LABELS = { scheda: "Scheda/Esercizi", prenotazioni: "Prenotazioni", pagamenti: "Pagamenti", generale: "Nota generale" };

export default function MessagesAdminPage() {
  const [messages, setMessages] = useState([]);
  const [selected, setSelected] = useState(null);
  const [reply, setReply] = useState("");
  const [filter, setFilter] = useState("all");

  const load = async () => {
    try { const { data } = await api.get("/chat/messages"); setMessages(data); } catch (e) { toast.error(formatApiError(e)); }
  };
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);

  const filtered = messages.filter(m => filter === "all" ? true : filter === "unread" ? !m.read_by_admin : !!m.admin_reply);
  const unread = messages.filter(m => !m.read_by_admin).length;

  const markRead = async (m) => { if (!m.read_by_admin) { await api.post(`/chat/messages/${m.id}/read`); load(); } };
  const sendReply = async () => {
    if (!reply.trim() || !selected) return;
    try {
      await api.post(`/chat/messages/${selected.id}/reply`, { reply });
      toast.success("Risposta inviata");
      setReply(""); load();
      setSelected({ ...selected, admin_reply: reply });
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div>
      <div className="label-caps">Messaggi clienti</div>
      <h2 className="font-heading font-black uppercase tracking-tighter text-3xl mt-1 mb-6 flex items-center gap-3">
        {messages.length} messaggi
        {unread > 0 && <span className="text-sm bg-[#FF3366] text-white px-2 py-1">{unread} nuovi</span>}
      </h2>

      <div className="inline-flex border border-white/10 mb-4">
        {[["all", "Tutti"], ["unread", "Non letti"], ["replied", "Con risposta"]].map(([k, l]) => (
          <button key={k} onClick={() => setFilter(k)} data-testid={`msg-filter-${k}`}
            className={`px-4 py-2 font-heading uppercase tracking-widest text-xs transition-colors border-l first:border-l-0 border-white/10 ${filter === k ? "bg-[#A855F7] text-white" : "text-white/60 hover:text-white"}`}>{l}</button>
        ))}
      </div>

      <div data-testid="admin-messaging-frame" className="border-4 border-white p-2 sm:p-3 bg-[#120B19] grid grid-cols-1 lg:grid-cols-[380px_1fr] gap-4">
        <div className="card-surface max-h-[70vh] overflow-y-auto">
          {filtered.length === 0 && <div className="p-6 text-white/40 text-sm text-center">Nessun messaggio.</div>}
          {filtered.map(m => (
            <button key={m.id} data-testid={`msg-${m.id}`}
              onClick={() => { setSelected(m); setReply(""); markRead(m); }}
              className={`w-full text-left p-3 border-b border-white/5 hover:bg-white/5 ${selected?.id === m.id ? "bg-white/10" : ""}`}>
              <div className="flex items-center justify-between">
                <div className="font-heading font-bold text-sm">{m.client_name}</div>
                {!m.read_by_admin && <span className="w-2 h-2 bg-[#FF3366]"></span>}
              </div>
              <div className="text-[10px] uppercase tracking-widest text-[#A855F7]">{CAT_LABELS[m.category] || m.category}</div>
              <div className="text-xs text-white/60 mt-1 line-clamp-2">{m.text}</div>
              <div className="text-[10px] text-white/30 mt-1">{new Date(m.created_at).toLocaleString("it-IT")}</div>
            </button>
          ))}
        </div>

        <div className="card-surface p-6 min-h-[300px]">
          {!selected && <div className="text-white/40 text-center py-16 flex flex-col items-center gap-3"><MessageCircle size={28} /> Seleziona un messaggio</div>}
          {selected && (
            <div className="space-y-4">
              <div>
                <div className="label-caps">{selected.client_name} · {CAT_LABELS[selected.category]}</div>
                <div className="text-white/50 text-xs">{new Date(selected.created_at).toLocaleString("it-IT")}</div>
              </div>
              <div className="bg-white/5 border border-white/10 p-4 whitespace-pre-wrap text-sm">{selected.text}</div>
              {selected.admin_reply && (
                <div className="border-l-2 border-[#A855F7] pl-3">
                  <div className="label-caps mb-1">Tua risposta</div>
                  <div className="text-sm whitespace-pre-wrap">{selected.admin_reply}</div>
                </div>
              )}
              <div>
                <div className="label-caps mb-2">{selected.admin_reply ? "Aggiorna risposta" : "Rispondi"}</div>
                <textarea rows={4} value={reply} onChange={e => setReply(e.target.value)} data-testid="admin-reply-text"
                  placeholder="Scrivi qui la tua risposta…"
                  className="w-full bg-transparent border border-white/15 p-3 text-white text-sm focus:border-[#A855F7] outline-none" />
                <button onClick={sendReply} data-testid="admin-reply-send" className="btn-primary mt-2 flex items-center gap-2">
                  <Send size={14} /> Invia risposta
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
